<template>
  <div class="campaign-footer">
    <div class="left-container">
      <img src="@/assets/campaign/rz_logo.svg" alt="Roanuz Logo" />
      © Copyright Roanuz Softwares Private Limited. All rights reserved
    </div>
    <div class="right-container">
      <ul>
        <li
          v-for="link in footerLinks"
          :key="link.key"
        >
          <rz-link-item v-if="link" :link="link"></rz-link-item>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CampaignFooter',
  props: {
    footerLinks: {
      type: Array,
    },
  },
};
</script>
<style lang="scss" scoped>
.campaign-footer {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: size(12) size(20);
  max-width: size(320);
  gap: size(12);
  flex-direction: column;

  @media screen and (min-width:  $breakpoint-md) {
    max-width: size(700);
    flex-direction: row;
    padding: size(20);
  }

  @media screen and (min-width:  $breakpoint-lg) {
    max-width: size(1200);
  }

  .left-container {
    display: flex;
    align-items: center;
    gap: size(12);
    color: var(--rs-black-color);
    font-size: size(16);
    line-height: size(24);
  }
  .right-container {
    font-size: size(16);
    line-height: size(24);
  }
}
</style>
